import { render, staticRenderFns } from "./JspritTest.vue?vue&type=template&id=6491f7b1&scoped=true"
import script from "./JspritTest.vue?vue&type=script&lang=js"
export * from "./JspritTest.vue?vue&type=script&lang=js"
import style0 from "./JspritTest.vue?vue&type=style&index=0&id=6491f7b1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6491f7b1",
  null
  
)

export default component.exports